




















































































































































































































































































































































import {Component, Prop, Vue} from 'vue-property-decorator';

import {
    ComponentDoc,
    EventDescriptor,
    MethodDescriptor,
    PropDescriptor,
    SlotDescriptor
} from 'vue-inbrowser-compiler-utils';
import MarkdownIt from 'markdown-it';
import JdsButton from "@/design-system/components/Button/JdsButton.vue"
import JdsToolbar from "@/design-system/patterns/JdsToolbar.vue"
import JdhHeightTransition from "@/design-system/shared/JdhHeightTransition.vue"
@Component({
    components: {JdhHeightTransition, JdsToolbar, JdsButton}
})
export default class JdiDocs extends Vue {
    @Prop() docs!: ComponentDoc;

    showChangelog = false;

    protected md: MarkdownIt|null = null;

    mounted() {
        this.md = new MarkdownIt();
    }

    get name() {
        if (!this.docs) return '';
        return this.docs.displayName;
    }

    get description() {
        if (!this.docs) return '';
        return this.parse(<string> this.docs.description);
    }


    get published() {
        if (!this.docs.tags || !this.docs.tags.hasOwnProperty('published')) return false;
        return (this.docs.tags.published[0] as any).description;
    }

    get changelog () {
        if (!this.docs.tags || !this.docs.tags.hasOwnProperty('changelog')) return [];
        return this.docs.tags.changelog.slice().reverse();
    }

    get analytics () {
        if (!this.docs.tags || !this.docs.tags.hasOwnProperty('analytics')) return [];
        return this.docs.tags.analytics.map((event: string) => {
            let eventName = event.description.split(" ")[0]
            let eventDescription = event.description.match(/^(\S+) (.*)$/)[2]
            let params = [];

            if (this.docs.tags.hasOwnProperty('analyticsParam')) {
                params = this.docs.tags.analyticsParam.filter((data: string) => {
                    return data.description.split(" ")[0] === eventName
                }).map((data: string) => {
                    return {
                        name: data.description.split(" ")[1],
                        description: data.description.match(/^(\S+) (\S+) (.*)$/)[3]
                    }
                })
            }

            return {
                name: eventName,
                description: eventDescription,
                params: params
            }
        });
    }

    // deals with the special props for AnalyticsMixin.
    get props(): PropDescriptor[] {
        if (this.docs.props) {
            return this.docs.props.filter(({name}) => !['track', 'trackResource'].includes(name))
        } else {
            return [];
        }
    }

    // reverse of the above.
    get analyticsProps(): PropDescriptor[] {
        if (this.docs.props) {
            return this.docs.props.filter(({name}) => ['track', 'trackResource'].includes(name))
        } else {
            return [];
        }
    }

    get events(): EventDescriptor[] {
        return this.docs.events ?? [];
    }

    get slots(): SlotDescriptor[] {
        return this.docs.slots ?? [];
    }

    get methods(): MethodDescriptor[] {
        return this.docs.methods ?? [];
    }

    parse(i: string|boolean) {
        if (i && this.md && i !== true) return this.md.render(i);
        return '';
    }

    emptyStringCheck(value:string) {
        if (value === '""' || value === "''") { return "(Empty string)"}
        return value;
    }
}
